import { BpModel } from "../models/societe-linked/bp/bp.model";

export class BpValidationModel {
    bp: BpModel;
    commentaire: string;
}
